/*
 * Volume quote
 * - Product pages: between threshold and cap, shows "Request Quote" as the primary button and demotes
 *   Add to Cart to secondary. Above the cap, Add to Cart is hidden and only Request Quote remains.
 * - Cart page / drawer: caps line quantities at the cap and links to the quote page.
 * Config comes from snippets/volume-quote-config.liquid (Theme settings > Volume quote).
 */
(function () {
  var cfg = window.volumeQuote;
  if (!cfg || !cfg.pageUrl) return;

  var THRESHOLD = parseInt(cfg.threshold, 10) || 10;
  var CAP = parseInt(cfg.cap, 10) || 50;
  if (CAP < THRESHOLD) CAP = THRESHOLD;

  function quoteUrl(variantId, qty, handle) {
    var url = cfg.pageUrl + (cfg.pageUrl.indexOf('?') === -1 ? '?' : '&');
    url += 'variant=' + encodeURIComponent(variantId || '') + '&quantity=' + encodeURIComponent(qty || THRESHOLD + 1);
    if (handle) url += '&handle=' + encodeURIComponent(handle);
    return url;
  }

  function productHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  /* ---------- Product form ---------- */

  function setupProductForm(pf) {
    if (pf.dataset.vqReady) return;
    var form = pf.querySelector('form');
    var addBtn = pf.querySelector('button[name="add"]');
    var row = pf.querySelector('.product-form__buttons-row');
    if (!form || !addBtn || !row) return;
    pf.dataset.vqReady = '1';

    var qtyInput = form.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"][form="' + form.id + '"]');
    var idInput = form.querySelector('input[name="id"]');

    var quoteBtn = document.createElement('a');
    quoteBtn.className = 'button button--primary product-form__submit volume-quote__button focus-inset';
    quoteBtn.hidden = true;
    quoteBtn.setAttribute('role', 'button');
    quoteBtn.innerHTML = '<span>' + cfg.buttonLabel + '</span>';
    addBtn.insertAdjacentElement('afterend', quoteBtn);

    var hint = document.createElement('p');
    hint.className = 'volume-quote__hint';
    hint.hidden = true;
    var buttons = row.parentElement;
    buttons.appendChild(hint);

    var wasDynamicPrimary = addBtn.classList.contains('button--primary');
    var addLabelEl = addBtn.querySelector('.button__label') || addBtn.querySelector('span');
    var addLabelDefault = addLabelEl ? addLabelEl.firstChild && addLabelEl.firstChild.nodeType === 3 ? addLabelEl.firstChild.textContent : addLabelEl.textContent : '';

    function fill(str, qty) {
      return String(str || '').replace(/\[qty\]/g, qty).replace(/\[threshold\]/g, THRESHOLD).replace(/\[cap\]/g, CAP);
    }
    function setAddLabel(text) {
      if (!addLabelEl) return;
      var node = addLabelEl.firstChild;
      if (node && node.nodeType === 3) node.textContent = text; else addLabelEl.insertBefore(document.createTextNode(text), addLabelEl.firstChild);
    }

    function currentQty() {
      var v = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return isNaN(v) || v < 1 ? 1 : v;
    }

    function refresh() {
      var qty = currentQty();
      var variantId = idInput ? idInput.value : '';
      quoteBtn.href = quoteUrl(variantId, qty, pf.dataset.productHandle || productHandle());
      quoteBtn.querySelector('span').textContent = fill(cfg.buttonLabel, qty);

      if (qty > CAP) {
        pf.classList.add('volume-quote--cap');
        pf.classList.remove('volume-quote--offer');
        quoteBtn.hidden = false;
        addBtn.hidden = true;
        hint.innerHTML = fill(cfg.capHint, qty);
        hint.hidden = false;
      } else if (qty > THRESHOLD) {
        pf.classList.add('volume-quote--offer');
        pf.classList.remove('volume-quote--cap');
        quoteBtn.hidden = false;
        addBtn.hidden = false;
        addBtn.classList.remove('button--primary');
        addBtn.classList.add('volume-quote__add-link');
        if (cfg.addInsteadLabel) setAddLabel(fill(cfg.addInsteadLabel, qty));
        hint.innerHTML = fill(cfg.hint, qty);
        hint.hidden = false;
      } else {
        pf.classList.remove('volume-quote--offer', 'volume-quote--cap');
        quoteBtn.hidden = true;
        addBtn.hidden = false;
        addBtn.classList.remove('volume-quote__add-link');
        if (wasDynamicPrimary) addBtn.classList.add('button--primary');
        if (cfg.addInsteadLabel && addLabelDefault) setAddLabel(addLabelDefault);
        hint.hidden = true;
      }
    }

    if (qtyInput) {
      ['input', 'change', 'keyup', 'paste'].forEach(function (ev) {
        qtyInput.addEventListener(ev, function () { setTimeout(refresh, 0); });
      });
      // The theme's quantity-input buttons dispatch change on the input already; also catch clicks directly.
      var qi = qtyInput.closest('quantity-input');
      if (qi) qi.addEventListener('click', function () { setTimeout(refresh, 0); });
    }
    // Variant changes swap the hidden id input value
    if (idInput) {
      var mo = new MutationObserver(refresh);
      mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) setTimeout(refresh, 50);
    });

    // Belt and braces: never let an over-cap quantity reach the cart.
    form.addEventListener('submit', function (e) {
      if (currentQty() > CAP) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = quoteBtn.href;
      }
    }, true);

    refresh();
  }

  function scanProductForms(root) {
    (root || document).querySelectorAll('.product__buy-buttons product-form, product-form.product-form').forEach(setupProductForm);
  }

  /* ---------- Cart guard ---------- */

  function resolveCartVariant(input, cb) {
    if (input.dataset.variantId) return cb(input.dataset.variantId);
    var idx = parseInt(input.dataset.index, 10);
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = cart.items && cart.items[idx - 1];
        if (item) input.dataset.variantId = item.variant_id;
        cb(item ? item.variant_id : '');
      })
      .catch(function () { cb(''); });
  }

  function cartNotice(input) {
    resolveCartVariant(input, function (variantId) { renderCartNotice(input, variantId); });
  }

  function renderCartNotice(input, variantId) {
    var line = input.closest('.cart-item, tr, li') || input.parentElement;
    var target = line && (line.querySelector('.cart-item__error-text'));
    var msg = cfg.cartNotice;
    var link = ' <a class="volume-quote__cart-link" href="' + quoteUrl(variantId, CAP + 1) + '">' + cfg.quoteLinkLabel + '</a>';
    if (target) {
      target.innerHTML = msg + link;
      var wrap = target.parentElement;
      if (wrap) wrap.classList.add('volume-quote__cart-error');
    } else {
      var n = line.querySelector('.volume-quote__cart-notice');
      if (!n) {
        n = document.createElement('p');
        n.className = 'volume-quote__cart-notice caption';
        line.appendChild(n);
      }
      n.innerHTML = msg + link;
    }
  }

  // The theme re-renders cart line items after a quantity change, which wipes any inline notice.
  // Remember which line was capped and re-apply the notice once the cart has re-rendered.
  var pendingNotices = {};
  function rememberNotice(input) {
    pendingNotices[input.dataset.index] = { variantId: input.dataset.variantId || '', at: Date.now() };
    clearTimeout(rememberNotice.t);
    rememberNotice.t = setTimeout(function () { replayNotices(false); }, 1500);
  }
  function replayNotices(clear) {
    Object.keys(pendingNotices).forEach(function (idx) {
      var p = pendingNotices[idx];
      if (Date.now() - p.at > 15000) { delete pendingNotices[idx]; return; }
      document.querySelectorAll('input[name="updates[]"][data-index="' + idx + '"]').forEach(function (inp) {
        if (p.variantId && !inp.dataset.variantId) inp.dataset.variantId = p.variantId;
        if (parseInt(inp.value, 10) >= CAP) cartNotice(inp);
      });
      if (clear) delete pendingNotices[idx];
    });
  }
  if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(function () { replayNotices(true); }, 100); });
  }

  function guardCartInput(input) {
    var v = parseInt(input.value, 10);
    if (!isNaN(v) && v > CAP) {
      input.value = CAP;
      rememberNotice(input);
      cartNotice(input);
      return true;
    }
    return false;
  }

  // Capture phase so the value is clamped before cart.js reads it.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[name="updates[]"]')) guardCartInput(t);
  }, true);

  // Quantity plus buttons in the cart: stop stepping past the cap.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('quantity-input button[name="plus"]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[name="updates[]"]');
    if (input && parseInt(input.value, 10) >= CAP) {
      e.preventDefault();
      e.stopImmediatePropagation();
      cartNotice(input);
    }
  }, true);

  /* ---------- Cart nudge (drawer + cart page) ---------- */

  var cartNudgeTimer = null;
  function scheduleCartNudge(delay) {
    clearTimeout(cartNudgeTimer);
    cartNudgeTimer = setTimeout(renderCartNudge, delay || 200);
  }

  function renderCartNudge() {
    var ctas = document.querySelectorAll('.cart__ctas');
    if (!ctas.length) return;
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = 0, items = [];
        (cart.items || []).forEach(function (it) {
          total += it.quantity;
          items.push(it.variant_id + ':' + it.quantity);
        });
        var show = total > THRESHOLD;
        var url = cfg.pageUrl + (cfg.pageUrl.indexOf('?') === -1 ? '?' : '&') + 'items=' + encodeURIComponent(items.join(','));
        ctas.forEach(function (cta) {
          var panel = cta.querySelector('.volume-quote__cart-panel');
          if (!show) { if (panel) panel.remove(); return; }
          if (!panel) {
            panel = document.createElement('div');
            panel.className = 'volume-quote__cart-panel';
            var checkout = cta.querySelector('[name="checkout"]');
            if (checkout) cta.insertBefore(panel, checkout); else cta.insertBefore(panel, cta.firstChild);
          }
          var text = (cfg.cartNudgeText || '').replace('[total]', total).replace('[threshold]', THRESHOLD);
          var html =
            '<p class="volume-quote__cart-panel-title">' + (cfg.cartNudgeTitle || '') + '</p>' +
            '<p class="volume-quote__cart-panel-text">' + text + '</p>' +
            '<a class="button button--primary button--full-width volume-quote__cart-panel-button focus-inset" href="' + url + '">' + (cfg.cartNudgeButton || cfg.buttonLabel) + '</a>';
          if (panel.innerHTML !== html) panel.innerHTML = html;
        });
      })
      .catch(function () {});
  }

  if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { scheduleCartNudge(250); });
  }

  /* ---------- Boot ---------- */

  function init() {
    scanProductForms();
    scheduleCartNudge(50);
    // The drawer re-renders its contents after every add/change; catch anything the pubsub event misses.
    function isOurs(n) { return n.nodeType === 1 && n.classList && n.classList.contains('volume-quote__cart-panel'); }
    function observeCart(el) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.target.closest && m.target.closest('.volume-quote__cart-panel')) continue;
          var nodes = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes));
          if (nodes.length && nodes.every(isOurs)) continue;
          scheduleCartNudge(300);
          return;
        }
      }).observe(el, { childList: true, subtree: true });
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) observeCart(drawer);
    var cartItems = document.querySelector('cart-items');
    if (cartItems) observeCart(cartItems);
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1) {
            if (n.matches && n.matches('product-form')) setupProductForm(n);
            else scanProductForms(n);
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function () { scanProductForms(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
